var RESEND_CODE_STATUS = /* @__PURE__ */ ((RESEND_CODE_STATUS2) => {
  RESEND_CODE_STATUS2["READY"] = "ready";
  RESEND_CODE_STATUS2["SENDING"] = "sending";
  RESEND_CODE_STATUS2["ON_COOLDOWN"] = "on_cooldown";
  return RESEND_CODE_STATUS2;
})(RESEND_CODE_STATUS || {});
const WsTwoFactorAuthenticationInputEnum = {
  ResendCodeStatus: RESEND_CODE_STATUS
};
export {
  RESEND_CODE_STATUS,
  WsTwoFactorAuthenticationInputEnum,
  WsTwoFactorAuthenticationInputEnum as default
};
//# sourceMappingURL=WsTwoFactorAuthenticationInput.enum.es.js.map
